<template>
  <div>
    <vue-headful :title="doctitle" />
    <!-- Mobile top image -->
    <b-container fluid class="d-md-none animations">
      <b-row>
        <b-col class="p-0">
          <!-- Mobile top background -->
          <b-img
            src="https://res.cloudinary.com/oredev/image/upload/v1744609660/2025/Line-up_page/line-up_mobile.png"
            fluid-grow
          />
          <!-- Floating blue planet -->
          <b-img
            class="position-absolute transform-blue-planet"
            src="https://res.cloudinary.com/oredev/image/upload/v1744609659/2025/Line-up_page/blue_planet.png"
            style="width: 20vw; left: 2vw; top: 9vw; z-index: 0"
            alt=""
            aria-hidden="true"
          />
          <!-- Floating purple planet -->
          <b-img
            class="position-absolute transform-purple-planet"
            style="width: 23vw; left: 27vw; top: 5vw; z-index: 0"
            src="https://res.cloudinary.com/oredev/image/upload/v1744609661/2025/Line-up_page/purple_planet.png"
            alt=""
            aria-hidden="true"
          />
        </b-col>
      </b-row>
    </b-container>
    <!-- Desktop top image -->
    <b-container fluid class="d-none d-md-block animations">
      <b-row>
        <b-col class="p-0">
          <!-- Desktop top background -->
          <b-img
            src="https://res.cloudinary.com/oredev/image/upload/v1746685471/2025/Line-up_page/line-up_page_alien.png"
            fluid-grow
          />
          <!-- Alien cactus gif -->
          <b-img
            class="position-absolute"
            style="width: 18vw; left: 9vw; top: 6vw; z-index: 0"
            src="https://res.cloudinary.com/oredev/image/upload/v1744609661/2025/Line-up_page/alien.gif"
            alt=""
            aria-hidden="true"
          />
          <!-- Floating moon -->
          <b-img
            class="position-absolute transform-moon"
            style="width: 13vw; left: 1vw; top: 5vw; z-index: 0"
            src="https://res.cloudinary.com/oredev/image/upload/v1744609661/2025/Line-up_page/moon.png"
            alt=""
            aria-hidden="true"
          />
          <!-- Floating blue planet -->
          <b-img
            class="position-absolute transform-blue-planet"
            src="https://res.cloudinary.com/oredev/image/upload/v1744609659/2025/Line-up_page/blue_planet.png"
            style="width: 6vw; left: 58vw; top: 5vw; z-index: 0"
            alt=""
            aria-hidden="true"
          />
          <!-- Floating purple planet -->
          <b-img
            class="position-absolute transform-purple-planet"
            style="width: 9vw; left: 65vw; top: 3vw; z-index: 0"
            src="https://res.cloudinary.com/oredev/image/upload/v1744609661/2025/Line-up_page/purple_planet.png"
            alt=""
            aria-hidden="true"
          />
        </b-col>
      </b-row>
    </b-container>

    <b-container fluid class="filter-container">
      <b-row>
        <b-col>
          <h1 class="text-center">This year's speakers</h1>
        </b-col>
      </b-row>
      <b-container style="max-width: 540px" class="filter-spans mb-4">
        <b-row>
          <b-col class="d-flex justify-content-between">
            <span>
              <a
                :style="
                  selectedTags.length == tags_tagList.length
                    ? 'text-decoration: underline'
                    : ''
                "
                @click="selectAllTags()"
                >Select All</a
              >
            </span>
            <span>Categories selected: {{ selectedTags.length }}</span>
          </b-col>
        </b-row>
      </b-container>
    </b-container>

    <!--  TAGS/TRACKS FILTER -->
    <b-container fluid class="tracks-container">
      <div class="tracks-button-wrapper">
        <button
          class="tag-btn"
          v-for="(tag, index) in tags_getOrderedTagList()"
          :key="index"
          @click="toggleTagInUrl(tag.tag)"
          :style="[tags_activeBg(tag.tag)]"
          style="z-index: 99"
        >
          <b-img :src="tag.icon" alt="" aria-hidden="true" />{{
            tag.name ? tag.name : tag.tag
          }}
        </button>
      </div>
    </b-container>
    <div
      v-if="$store.getters.getSpeakers.length"
      class="margin-images-container"
      style="margin-left: auto; margin-right: auto"
    >
      <SpeakerWall />

      <!-- Gutter-images -->

      <b-img
        src="https://res.cloudinary.com/oredev/image/upload/v1742800150/2025/Margin-images/Shape_orange.png"
        class="position-absolute gutter-image"
        style="width: 8%; right: 5%; top: 0px"
        alt=""
        aria-hidden="true"
      />
      <b-img
        src="https://res.cloudinary.com/oredev/image/upload/v1742800150/2025/Margin-images/planet.png"
        class="position-absolute gutter-image"
        style="width: 14%; left: 1%; top: 500px"
        alt=""
        aria-hidden="true"
      />
      <b-img
        src="https://res.cloudinary.com/oredev/image/upload/v1742800150/2025/Margin-images/pink_planet.png"
        class="position-absolute gutter-image pink-planet"
        style="width: 12%; right: -3%; top: 1075px"
        alt=""
        aria-hidden="true"
      />
      <b-img
        src="https://res.cloudinary.com/oredev/image/upload/v1743156669/2025/Margin-images/shooting_star_yellow.png"
        class="position-absolute gutter-image"
        style="width: 11%; left: 2%; top: 1490px"
        alt=""
        aria-hidden="true"
      />
    </div>

    <!-- Mobile Bottom Images -->
    <b-img
      src="https://res.cloudinary.com/oredev/image/upload/v1742800150/2025/Margin-images/shooting_star_yellow.png"
      class="d-block d-sm-none mx-auto my-5"
      style="width: 36vw"
      alt=""
      aria-hidden="true"
    />
    <b-img
      src="https://res.cloudinary.com/oredev/image/upload/v1743156660/2025/Footer_pages/img_11.png"
      class="d-block d-sm-none mx-auto"
      style="width: 86vw"
      alt="A dancer in a costume of green netting"
    />
    <!-- Desktop Bottom Images -->
    <b-container
      fluid
      class="position-relative d-none d-sm-block"
      style="height: 20vw"
    >
      <b-img
        src="https://res.cloudinary.com/oredev/image/upload/v1743156660/2025/Footer_pages/img_9.png"
        class="position-absolute"
        style="width: 23vw; left: 4vw; bottom: -4vw"
      />
      <b-img
        src="https://res.cloudinary.com/oredev/image/upload/v1743156661/2025/Footer_pages/img_10.png"
        class="position-absolute"
        style="width: 23vw; left: 36vw; bottom: -8vw"
      />
      <b-img
        src="https://res.cloudinary.com/oredev/image/upload/v1743156660/2025/Footer_pages/img_11.png"
        class="position-absolute"
        style="width: 23vw; left: 64vw; bottom: -3vw"
      />
    </b-container>
  </div>
</template>

<script>
import tags from "@/mixins/tags";
import SpeakerWall from "@/components/SpeakerWall.vue";

export default {
  name: "Lineup",
  mixins: [tags],
  components: {
    SpeakerWall,
  },
  data() {
    return {
      doctitle: "Line Up - " + this.$store.state.conferencename,
    };
  },
  computed: {
    selectedTags() {
      const queryTags = this.$route.query.tags;
      const tagList = typeof queryTags === "string" ? queryTags.split(",") : [];
      return tagList;
    },
  },
  methods: {
    toggleTagInUrl(tag) {
      const queryTags = this.$route.query.tags;

      let tagList = typeof queryTags === "string" ? queryTags.split(",") : [];

      // If all tags selected, only choose pressed tag
      if (tagList.length == 12) {
        tagList = [tag];
      }
      // If included remove the tag
      else if (tagList.includes(tag)) {
        tagList = tagList.filter((t) => t !== tag);
        // else add the tag
      } else {
        tagList.push(tag);
      }

      // If list becomes empty → reset to all tags
      if (tagList.length === 0) {
        this.selectAllTags();
      } else {
        this.$router.replace({
          query: {
            tags: tagList.join(","),
          },
        });
      }
    },
    selectAllTags() {
      const allTags = this.tags_tagList.map((t) => t.tag);
      this.$router.replace({
        query: {
          tags: allTags.join(","),
        },
      });
    },
  },
  mounted: function () {
    const queryTags = this.$route.query.tags;
    // If no tags present in URL, set all
    if (!queryTags) {
      const allTags = this.tags_tagList.map((t) => t.tag);
      this.$router.replace({
        query: {
          tags: allTags.join(","),
        },
      });
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@use "@/styles/variables.scss" as *;

.animations {
  .transform-blue-planet {
    animation: float-mobile 4s ease-in-out infinite;
  }
  .transform-purple-planet {
    animation: float-mobile 5s ease-in-out infinite;
  }
  @media (min-width: 576px) {
    .transform-moon {
      animation: float-desktop 4s ease-in-out infinite;
    }
    .transform-blue-planet {
      animation: float-desktop 3s ease-in-out infinite;
    }
    .transform-purple-planet {
      animation: float-desktop 5s ease-in-out infinite;
    }
  }

  /* Animation for mobile */
  @keyframes float-mobile {
    0%,
    100% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(-4vw);
    }
  }

  /* Animation for desktop */
  @keyframes float-desktop {
    0%,
    100% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(-2vw);
    }
  }
}

h1 {
  font-weight: 400;
  letter-spacing: 0;
  font-size: 24px;
  @media (min-width: 577px) {
    font-size: 32px;
  }
  @media (min-width: 768px) {
    font-size: 48px;
  }
}

.filter-container {
  @media (min-width: 768px) {
    margin-top: -6vw;
  }
  .filter-spans span {
    font-family: Lexend, sans-serif;
    font-weight: 400;
    font-size: 16px;
    line-height: 100%;
    letter-spacing: 0.05rem;
    a {
      font-weight: 600;
    }
    @media (min-width: 768px) {
      font-size: 20px;
    }
  }
}

.tracks-container {
  @media (min-width: 960px) {
    max-width: 960px;
  }
  @media (min-width: 1170px) {
    max-width: 1170px;
  }
  .tracks-button-wrapper {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;

    // Default: left-aligned
    justify-content: flex-start;

    @media (min-width: 768px) {
      justify-content: center;
    }
  }
}

.tag-btn {
  font-family: Lexend, sans-serif;
  font-weight: 500;
  font-size: 16px;
  letter-spacing: 0.05em;
  line-height: 100%;

  border-radius: 10px;
  border: 3px solid $dark-brown;
  color: $dark-brown;
  background-color: $white;

  padding: 5px 15px;
  @media (min-width: 577px) {
    padding: 16px 24px;
  }

  &:hover,
  &:focus-visible {
    outline: 3px solid $dark-brown;
    border: 3px solid $white;
  }

  img {
    width: 28px;
    margin-right: 10px;
  }
}

.margin-images-container {
  overflow-x: hidden;
  overflow-y: hidden;
  position: relative;
  max-width: 1900px;
  @media (min-width: 1900px) {
    .pink-planet {
      right: 0% !important;
    }
  }
}
.gutter-image {
  @media (max-width: 1399px) {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Lineup.vue